<template>
  <!-- 일렉트론과 동일하게 <v-app> 미사용. <v-app>로 감싸면 루트에 .v-application이 붙어
       vuetify 색상 유틸 클래스(.info/.success/.warning 등)가 앱의 동명 클래스를 !important로 덮어씀 -->
  <div id="app">
    <!-- 레이아웃 래퍼(.cont_fix)는 WindowLayer.vue가 제공 (일렉트론과 동일 구조) -->
    <router-view />

    <!-- setToast 토스트 표시 지점 (일렉트론 App.vue와 동일). vuex toast 상태를 Toast.vue가 렌더 -->
    <div class="toast_wrap"><Toast /></div>

    <!-- 실제 FCM 알림 토스트 표시 지점 (일렉트론 App.vue와 동일).
         WindowLayer.notiHandler가 this.$notify({ group: 'notification' })로 띄우는 토스트가 여기에 렌더됨 -->
    <notifications group="notification" width="400" classes="push_noti">
      <template slot="body" slot-scope="{ item, close }">
        <div class="vue-notification-template push_noti" @click="action_Notificaion(item, close)">
          <div class="notification-title">{{ item.title }}</div>
          <div class="notification-content">{{ item.text }}</div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import { ipcRenderer } from 'electron';
import Toast from './v2/views/Popups/Toast.vue';

export default {
  name: 'App',
  components: { Toast },
  methods: {
    // 알림 토스트 클릭 시: 닫고 일렉트론에 클릭 사실 전달 (일렉트론 App.vue와 동일)
    action_Notificaion(data, closeFunction) {
      closeFunction();
      ipcRenderer.send('Application.clickNotification', data.data);
    },
  },
};
</script>

<style scoped>
/* 일렉트론 App.vue와 동일: #app이 높이 기준(100%)을 잡아야 .cont_fix→.cc 높이 사슬이 이어짐 */
#app {
  height: 100%;
}
</style>
